module.exports = __webpack_public_path__ + "img/homeBg.53f8f5f9.png";